import { render, staticRenderFns } from "./PostListMod.vue?vue&type=template&id=4e2da3a0"
import script from "./PostListMod.vue?vue&type=script&lang=js"
export * from "./PostListMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports